export { Analytics as default } from '@hypotenuse/common/src/analytics/Analytics'
